import React from "react"

import IdVerificationFilter from './sections/IdVerificationFilter'
import AgeFilter from './sections/AgeFilter'
import GenderFilter from './sections/GenderFilter'
import LocationFilter from './sections/LocationFilter'

class WhoCanContactMeContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      gender_id: '',
      min_age_difference: '',
      max_age_difference: '',
      local_chats_only: '',
      loaded: false,
      timeout: null,
    }

    this.updateGender = this.updateGender.bind(this)
    this.updateProSettings = this.updateProSettings.bind(this)
    this.updateAge = this.updateAge.bind(this)
    this.toggleIdVerification = this.toggleIdVerification.bind(this)
    this.updateLocation = this.updateLocation.bind(this)
  }

  componentDidMount() {
    this.setState({
      gender_id: this.props.pro_settings != null ? this.props.pro_settings.gender_id : 1,
      min_age_difference: (this.props.pro_settings != null && this.props.pro_settings.min_age_difference != null)
        ? this.props.pro_settings.min_age_difference
        : 18,
      max_age_difference: (this.props.pro_settings != null && this.props.pro_settings.max_age_difference != null)
        ? this.props.pro_settings.max_age_difference
        : 152,
      local_chats_only: this.props.current_user.local_chats_only,
      loaded: true,
    })
  }

  updateGender(gender_id) {
    if (gender_id !== this.state.gender_id) {
      this.setState({ gender_id })
      this.updateProSettings({ gender_id })
    }
  }

  updateProSettings(data) {
    $.ajax({
      url: '/ajaxUpdateProSettings',
      dataType: 'JSON',
      type: 'POST',
      data: data,
      success: function(data) {
        const proSettings = JSON.parse(data.data.pro_settings)
        this.setState({
          min_age_difference: proSettings.min_age_difference,
          max_age_difference: proSettings.max_age_difference,
          gender_id: proSettings.gender_id,
        })
      }.bind(this),
      error: function(xhr, status, err) {
        console.log(`error is ${err}`)
      }.bind(this),
    })
  }

  updateAge(min_age, max_age) {
    if (!this.props.premiumUser) return

    this.setState({
      min_age_difference: min_age,
      max_age_difference: max_age,
    })

    const { timeout } = this.state
    clearTimeout(timeout)
    this.setState({
      timeout: setTimeout(() => {
        this.updateProSettings({
          min_age_difference: min_age,
          max_age_difference: max_age,
        })
      }, 1000),
    })
  }

  toggleIdVerification() {
    this.props.updateIdVerification()
  }

  updateLocation(value) {
    this.setState({ local_chats_only: value })
    this.props.updateUserSettings('local_chats_only', value)
  }

  render() {
    if (!this.state.loaded) {
      return null
    }

    return (
      <div className="matchFiltersModal__panel">
        <LocationFilter
          updateLocation={this.updateLocation}
          locals_only={this.state.local_chats_only}
          filter={false}
        />

        <GenderFilter
          selectedGender={this.state.gender_id}
          userGender={this.props.current_user.gender_id}
          toggleProModal={this.props.toggleProModal}
          premiumUser={this.props.premiumUser}
          updateGender={this.updateGender}
        />

        <AgeFilter
          min_age_difference={this.state.min_age_difference}
          max_age_difference={this.state.max_age_difference}
          current_user={this.props.current_user}
          updateAge={this.updateAge}
          premiumUser={this.props.premiumUser}
          toggleProModal={this.props.toggleProModal}
        />

        <IdVerificationFilter
          idVerification={this.props.idVerification}
          selected={this.props.current_user.verified_chats_only}
          toggleProModal={this.props.toggleProModal}
          toggleIdVerification={this.toggleIdVerification}
        />
      </div>
    )
  }
}

export default WhoCanContactMeContainer
